import sweetAlert from 'sweetalert';

// Generic, indeterminate progress dialog for long-running operations (e.g.
// preparing a large export). It shows a spinner and message in a
// non-dismissable sweetAlert; the caller calls hide() once the operation
// starts, completes, or errors. Reusable anywhere in Bobcat — pass whatever
// title/message/warning copy fits the operation.
const ProgressDialog = {
  // opts: { title, message, warning }
  //   message: string or array of strings (rendered as paragraphs)
  //   warning: optional emphasized line (e.g. "don't navigate away")
  show({ title, message, warning } = {}) {
    const content = document.createElement('div');
    content.className = 'progress-dialog';

    const spinner = document.createElement('div');
    spinner.className = 'progress-dialog__spinner';
    spinner.setAttribute('role', 'status');
    spinner.setAttribute('aria-label', 'Loading');
    content.appendChild(spinner);

    const body = document.createElement('div');
    body.className = 'progress-dialog__body';
    const lines = Array.isArray(message) ? message : [message];
    lines.filter(Boolean).forEach((line) => {
      const paragraph = document.createElement('p');
      paragraph.textContent = line;
      body.appendChild(paragraph);
    });
    if (warning) {
      const warningEl = document.createElement('p');
      warningEl.className = 'progress-dialog__warning';
      warningEl.textContent = warning;
      body.appendChild(warningEl);
    }
    content.appendChild(body);

    sweetAlert({
      title: title || '',
      content,
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false
    });
  },

  hide() {
    sweetAlert.close();
  }
};

export default ProgressDialog;
